<template>
  <div v-if="!this.isAvailable(['customer'])">
    <!--    <input class="form-control mb-2 mr-sm-2" type="text" id="example-date-input"-->
    <!--           v-model="data.partner_id" :disabled="data.disabled"-->
    <!--           required>-->

    <multiselect
      v-if="isAvailable(['admin', 'welder'])"
      v-model="data.partner_id"

      :options="partnerSelectorOptions.map((item) => item.value)"
      :disabled="isWorker()"
      :searchable="false"
      :close-on-select="false"
      :show-labels="false"

      placeholder="Pick a value"
    ></multiselect>

    <p v-else>***********</p>
  </div>
</template>

<script>
import api from "@/services/api";

import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  name: "partnerColumn",
  components: { multiselect: Multiselect },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(["meRoles", "partnerSelectorOptions"]),
  },

  methods: {
    async getParams(column) {
      try {
        const res = await api.get("/params/" + column);
        return res.data.map((item) => {
          return item.value;
        });
      } catch (e) {
        console.log(e);
      }
    },
    isWorker() {
      if (this.data.disabled) {
        return true;
      } else {
        return !this.isAvailable(["admin"]);
      }
    },
    isAvailable(roles) {
      return this.meRoles.map((item) => roles.includes(item)).includes(true);
    },
  },
};
</script>

<style scoped>
</style>
